import React, {type FC, memo} from "react"
import {ColourwayImageSlide} from "../../../ColourwayImageSlide"
import {ColourwaySwiperDetails, ColourwaySwiperDetailsProps} from "../../../ColourwaySwiperDetails"
import {SlideDetail} from "../../../../helpers"
import PsImageContainer from "../../../../../imageContainer"
import {EmptyDivider} from "../../../../components"

interface StandardColourwaySingleSlideProps {
    slide: SlideDetail
    imageDetails: ColourwaySwiperDetailsProps
    isOnServer?: boolean
}

const StandardColourwaySingleSlide: FC<StandardColourwaySingleSlideProps> = memo(
    ({slide, imageDetails, isOnServer = false}) => (
        <>
            <PsImageContainer data-testid="standard-image-container">
                <ColourwayImageSlide isActiveSlide {...slide} singleTile>
                    <ColourwaySwiperDetails {...imageDetails} isOnServer={isOnServer} />
                </ColourwayImageSlide>
            </PsImageContainer>
            <EmptyDivider />
        </>
    ),
)
StandardColourwaySingleSlide.displayName = "StandardColourwaySingleSlide"

export default StandardColourwaySingleSlide
